import {Map} from "immutable";

export const ADD_COMMON_FORM = Map({
    "margin": "Margin % to be held at disbursement",
    "anchor_unit": "Pricing per unit i.e. per tonne or per bag",
    "min_normal_roi":"Minimum value of normal roi for the program",
    "max_normal_roi":"Maximum value of normal roi for the program",
    "lending_partner": "Select the partner for which this scheme will be applicable",
    "tenor": "No disbursal will be processed if this tenor is breached",
    "overdue_tenor": "Overdue interest will be charged if this tenor is breached",
    "roi_structure": "Flat indicates single ROI is applicable before and after overdue tenor, Tiered indicates that there is tiering of ROI either within overdue tenor, or after overdue tenor, or both",
    "normal_roi": "For flat structure, enter the ROI applicable within overdue tenor. For tiered structure, enter the minimum ROI applicable within overdue tenor",
    "overdue_roi": "For flat structure, enter the ROI applicable after overdue tenor. For tiered structure, enter the maximum ROI applicable after overdue tenor",
    "stop_billing_applicable": "If Yes, further disbursals will be stopped if any invoice is not paid within Stop Billing Days of disbursal",
    "stop_billing_days": "Further disbursals will be stopped if any invoice is not paid within Stop Billing Days of disbursal",
    "cooling_period": "Period before tenor which is kept as buffer for collection purpose. Due date communicated to dealer will be lesser by this many days than the due date",
    "cashback_applicable": "Select Yes for Subvention Program",//"If this is a subvention program, click yes. If daily interest is applicable from Day 1, click no.",
    "dealer_perc": "Percentage of total cashback earnt to be transferred to Dealer",
    "seller_perc": "Percentage of total cashback earnt to be transferred to Seller",
    "progcap_perc": "Percentage of total cashback earnt to be transferred to Progcap",
    "disbursal_wait_days": "Period after invoice date post which invoice is eligible for disbursal",
    "subvention_perc": "Subvention % to be held at disbursement",
    "subvention_days": "This is derived from Subvention % and Normal ROI",
    "subvention_amount_per_unit": "Subvention amount per unit for the program",
    "scheme_id": "This is an identifier maintained by system. Please quote this ID when raising any issue to system administrator.",
    "interest_type": "Interest Charging Methodology (Flat / Reducing)",
    "instalment_frequency": "Instalment Frequency",
    "upfront_interest_deduction": "Percentage of Loan Amount deducted upfront to serve interest",
    "custom_frequency": "Days between 2 EMIs",
    "minimum_loan_amount": "Minimum Loan Amount",
    "maximum_loan_amount": "Maximum Loan Amount",
    "minimum_loan_tenure": "Minimum Loan Tenure",
    "maximum_loan_tenure": "Maximum Loan Tenure",
    "tl_normal_roi": "Annual ROI for term loan",
    "tl_overdue_roi": "Annual Overdue ROI for term loan",
    "grace_period_fi_date": "Period post which first instalment will be due after disbursal",
    "fixed_emi_date": "Applicable for monthly EMIs to use a constant date irrespective of the disbursal date",
    "fixed_emi_cut_off_date": "If disbursal happens upto the cut-off date, first EMI will be applicable next month else next to next month",
    "instalment_date_calculation": "Instalments date will be calculated basis this value",
    "grace_period_for_od_interest": "# Days from due date upto which penal interest will not be charged",
    "progcap_subvention_days": "Days for which Progcap will subvent the interest cost",
    "subvention_by": "Subvention cost will be borne by",
    "anchor": "This scheme will be applicable for below anchor",
    "proportion_of_payment_by_vendor":"This is applicable only when interest repayment selected both"
});

export const fieldsKeys = (fieldName) => {
    switch (fieldName) {
    case "Tenor in days": 
    case "Tenor (days)": return "tenor";
    case "Margin": return "margin";
    case "Overdue Tenor":
    case "Overdue Tenor (days)" : return "overdue_tenor";
    case "ROI Structure": return "roi_structure";
    case "Normal ROI": return "normal_roi";
    case "Overdue ROI": return "overdue_roi";
    case "Disbursal Wait days": return "disbursal_wait_days";
    case "Cooling Period": return "cooling_period";
    case "Subvention By": return "subvention_by";
    case "Progcap Subvention Days": return "progcap_subvention_days";
    case "Subvention Days": return "subvention_days";
    case "Subvention Percentage": return "subvention_perc";
    case "Stop Billing Days": return "stop_billing_days";
    case "Subvention %": return "subvention_perc";
    case "Cashback to Dealer": return "dealer_perc";
    case "Cashback to Seller": return "seller_perc";
    case "Cashback to Progcap": return "progcap_perc";
    default :  return "";
    }
};